export const invoiceConfigKey = ['invoiceConfig']
export const invoiceConfigKeyWithParams = (
  params: (string | number | undefined | string[])[]
) => [...invoiceConfigKey, ...params]
